import React from "react";
import Layout from "../components/layout";
import ComingSoon from "../components/comingSoon";
// import  { Container } from "../components/layout";
// import BackHeader from "../components/backHeader";
// import Input from "../components/inputContainer";
// import Card from "../components/card";

const Orders = () => {
  // const [editDetails, setEditDetails] = useState("");
  // const dummyData = [
  //   {
  //     productName: "Product 1",
  //     color: "Red",
  //     category: "Category 1",
  //     price: 100,
  //   },
  //   {
  //     productName: "Product 2",
  //     color: "Blue",
  //     category: "Category 2",
  //     price: 200,
  //   },
  //   {
  //     productName: "Product 3",
  //     color: "Green",
  //     category: "Category 3",
  //     price: 300,
  //   },
  // ];
  return (
    <Layout>
      {/* <Container>
        <div className="flex flex-wrap justify-between w-full h-full  overflow-auto">
          <div className="flex flex-col  py-2 px-2 md:px-14 w-full">
            <BackHeader
              title="Orders"
              rightSide={
                <div>
                  <Input.search placeholder="Search your " />
                </div>
              }
            />
            {editDetails && (
              <Card.AddPopUp removePopUp={() => setEditDetails("")}>
                <div className="p-4">
                  <h2 className="text-lg font-semibold">Product Details</h2>
                  <p>
                    <strong>Product Name:</strong> {editDetails.productName}
                  </p>
                  <p>
                    <strong>Color:</strong> {editDetails.color}
                  </p>
                  <p>
                    <strong>Category:</strong> {editDetails.category}
                  </p>
                  <p>
                    <strong>Price:</strong> ${editDetails.price}
                  </p>
                </div>
              </Card.AddPopUp>
            )}

            <div class="relative overflow-x-auto shadow-md sm:rounded-lg mt-5">
              <table class="w-full text-sm text-left rtl:text-right text-gray-500 ">
                <thead class="text-xs text-gray-700 uppercase bg-gray-50  ">
                  <tr>
                    <th scope="col" class="px-6 py-3">
                      Product name
                    </th>
                    <th scope="col" class="px-6 py-3">
                      Color
                    </th>
                    <th scope="col" class="px-6 py-3">
                      Category
                    </th>
                    <th scope="col" class="px-6 py-3">
                      Price
                    </th>
                    <th scope="col" class="px-6 py-3">
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {dummyData.map((item, index) => (
                    <tr key={index} class="bg-white border-b">
                      <th
                        scope="row"
                        class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap"
                      >
                        {item.productName}
                      </th>
                      <td class="px-6 py-4">{item.color}</td>
                      <td class="px-6 py-4">{item.category}</td>
                      <td class="px-6 py-4">${item.price}</td>
                      <td class="px-6 py-4">
                        <button
                          class="font-medium text-blue-600 hover:underline"
                          onClick={() => setEditDetails(item)}
                        >
                          Edit
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </Container> */}
      <ComingSoon/>
    </Layout>
  );
};

export default Orders;
